import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { IYearMonth } from '@/coreDomainsModule/date';
import DatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import { computed } from 'vue';
import { i18n } from '@/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'MonthPicker',
  props: {
    modelValue: { default: undefined },
    locale: { default: 'ja' },
    placeholder: { default: '年月を選択してください' },
    propFormat: { default: 'yyyy年M月' },
    useTeleport: { type: Boolean, default: true },
    minDate: { default: undefined },
    maxDate: { default: undefined }
  },
  emits: ["update:model-value", "open", "closed"],
  setup(__props: any, { emit: __emit }) {

const t = i18n.t;

// props
const props = __props;

/**
 * 最小日付をDate型に変換
 */
const minDateValue = computed(() => {
  if (!props.minDate) return undefined;
  // IYearMonthの月は1-indexed、DateコンストラクタのmonthIndexは0-indexed
  // その月の初日を設定
  return new Date(props.minDate.year, props.minDate.month - 1, 1);
});

/**
 * 最大日付をDate型に変換
 */
const maxDateValue = computed(() => {
  if (!props.maxDate) return undefined;
  // IYearMonthの月は1-indexed、DateコンストラクタのmonthIndexは0-indexed
  // その月の最終日を設定するため、翌月の0日目を指定
  return new Date(props.maxDate.year, props.maxDate.month, 0);
});

/**
 * 年月情報
 */
const yearMonthInfo = computed({
  // eslint-disable-next-line jsdoc/require-jsdoc
  get: () => {
    let getValue = props.modelValue;
    if (!getValue) return undefined;
    getValue = {
      year: getValue.year,
      month: getValue.month - 1,
    };
    return getValue;
  },
  // eslint-disable-next-line jsdoc/require-jsdoc
  set: (val) => {
    if (!val) return;
    // そのままだと、Date型の月情報と同じなので+1して返す
    val = {
      year: val.year,
      month: val.month + 1,
    };
    return emits('update:model-value', val);
  },
});

// emits
const emits = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DatePicker), {
    modelValue: yearMonthInfo.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((yearMonthInfo).value = $event)),
    teleport: _ctx.useTeleport,
    clearable: false,
    format: _ctx.propFormat,
    locale: props.locale,
    placeholder: _unref(t)(props.placeholder),
    "min-date": minDateValue.value,
    "max-date": maxDateValue.value,
    "month-picker": "",
    "auto-apply": "",
    onOpen: _cache[1] || (_cache[1] = ($event: any) => (emits('open'))),
    onClosed: _cache[2] || (_cache[2] = ($event: any) => (emits('closed')))
  }, null, 8, ["modelValue", "teleport", "format", "locale", "placeholder", "min-date", "max-date"]))
}
}

})